import { render, staticRenderFns } from "./SuppliesTable.vue?vue&type=template&id=12fe2b1a&"
import script from "./SuppliesTable.vue?vue&type=script&lang=ts&"
export * from "./SuppliesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports